import type { ReactNode } from "react";

type LabeledValueProperties = Readonly<{
  label: ReactNode;
  subLabel?: ReactNode;
  value?: string;
}>;

/** A static label/value pair for displaying a value that's never editable — no input, just text, for fields that never need the disabled-input treatment. */
export function LabeledValue({ label, subLabel, value }: LabeledValueProperties) {
  return (
    <div className="gap-(--spacing-1) flex flex-col">
      <div className="flex flex-col">
        <span className="text-primary text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height) font-(--font-weight-semibold)">
          {label}
        </span>
        {subLabel && <span className="text-primary text-[10px]">{subLabel}</span>}
      </div>
      <span className="text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height)">
        {value}
      </span>
    </div>
  );
}
